/* Product gallery desktop nav arrows - v3 */
(function () {
  var SVG_ARROW = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="8,4 14,10 8,16"/></svg>';

  function createNavDiv() {
    var nav = document.createElement('div');
    nav.className = 'product-gallery-nav no-js-hidden quick-add-hidden small-hide';

    var prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'product-gallery-nav__btn product-gallery-nav__btn--prev';
    prevBtn.setAttribute('aria-label', 'Previous image');
    prevBtn.innerHTML = SVG_ARROW;

    var nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'product-gallery-nav__btn product-gallery-nav__btn--next';
    nextBtn.setAttribute('aria-label', 'Next image');
    nextBtn.innerHTML = SVG_ARROW;

    nav.appendChild(prevBtn);
    nav.appendChild(nextBtn);
    return nav;
  }

  function initGalleryNav(mediaGallery) {
    if (mediaGallery.dataset.galleryNavInit) return;

    var sliderComp = mediaGallery.querySelector('slider-component[id^="GalleryViewer"]');
    if (!sliderComp) return;

    // Thumbnails are siblings of slider-component inside media-gallery
    var thumbItems = mediaGallery.querySelectorAll('[id^="GalleryThumbnails"] li');
    if (thumbItems.length <= 1) return;

    mediaGallery.dataset.galleryNavInit = '1';

    // Inject nav into slider-component if not already there
    if (!sliderComp.querySelector('.product-gallery-nav')) {
      sliderComp.appendChild(createNavDiv());
    }

    var navBtns = sliderComp.querySelectorAll('.product-gallery-nav__btn');

    navBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var thumbArr = Array.from(thumbItems);
        var currentIndex = -1;
        thumbArr.forEach(function(item, idx) {
          var b = item.querySelector('button');
          if (b && (b.getAttribute('aria-current') === 'true' || b.classList.contains('is-active') || b.getAttribute('aria-pressed') === 'true')) {
            currentIndex = idx;
          }
        });
        if (currentIndex === -1) currentIndex = 0;

        var isPrev = btn.classList.contains('product-gallery-nav__btn--prev');
        var nextIndex;
        if (isPrev) {
          nextIndex = currentIndex <= 0 ? thumbArr.length - 1 : currentIndex - 1;
        } else {
          nextIndex = currentIndex >= thumbArr.length - 1 ? 0 : currentIndex + 1;
        }

        var nextItem = thumbArr[nextIndex];
        if (!nextItem) return;
        var nextBtn = nextItem.querySelector('button');
        if (nextBtn) nextBtn.click();
      });
    });
  }

  function setup() {
    document.querySelectorAll('media-gallery').forEach(function (mg) {
      setTimeout(function () { initGalleryNav(mg); }, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(setup, 300);
  });
})();